// extracted by mini-css-extract-plugin
export default {"projects-table-container":"ProjectList_projects-table-container__T8VaG"};